import { Component, OnInit } from '@angular/core';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';

@Component({
    selector: 'mobile-app-privacy',
    template: `
I am the privacy component
`,
    standalone: false
})
export class MobileAppPrivacyComponent extends MobileAppWrapper<MobileAppPrivacyComponent> implements OnInit {
  ngOnInit() {}
}

